//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapActions,
  mapGetters,
} from 'vuex';
import Sidebar from '../shared-components/sidebar/Sidebar';
import Toolbar from '../shared-components/toolbar/Toolbar';
import resourceImportacao from '../common/resources/importacoes';
import resourceDicionario from '../common/resources/dicionario';
import resourceUsuario from '../common/resources/usuario';
import resourceControladorTrade from '../common/resources/controlador-trade/controlador-trade';
import { auth } from '../../../config/sso/auth';
import { showInitialLoading, hideInitialLoading } from '../../../common/functions/loading';
import menuList from '../menu/menu';
import TermoAceiteLogin from '../../../spa/termo-aceite/TermoAceiteLogin';
import resourceTermoAceite from '../common/resources/termo-aceite';


export default {
  name: 'Home',
  data() {
    return {
      importacaoResources: resourceImportacao(this.$resource),
      dicionarioResources: resourceDicionario(this.$resource),
      usuarioResources: resourceUsuario(this.$resource),
      controladorResources: resourceControladorTrade(this.$resource),
      termoAceiteResources: resourceTermoAceite(this.$resource),
      dicionarioCarregado: false,
      eventLoop: null,
      eventLoopTimer: 10E3,
      mensagemModalInicializacao: '',
      menuList: menuList(this),
      usuarioInfo: {},
      abrirMenu: false,
      recarregar: false,
      termos: [],
      aceito: false,
    };
  },
  components: {
    Sidebar,
    Toolbar,
    TermoAceiteLogin,
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
      'getUsuario',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...mapGetters('implantacao', [
      'implantacao',
      'indModoVarejo',
    ]),
    ...mapGetters('controlador', [
      'getControladoreSelecionado',
    ]),
    canAccessPageList() {
      if (!this.getAllRoles) {
        return [];
      }
      return this.getAllRoles
        .filter(el => el.indexOf('_PAGINA') !== -1 || el.indexOf('_CRUD') !== -1);
    },
    canImport() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el.endsWith('_IMPORTAR') || el.endsWith('_CRUD')).length;
    },
    filteredMenuList() {
      if (!this.getAllRoles || !this.getAllRoles.length) {
        return [];
      }
      const filter = [];
      const routesFiltradas = [];
      this.menuList
        .forEach((m) => {
          if (m.sub) {
            const subFiltrado = this.filtrarSubMenu(m.sub);
            if (subFiltrado.length) {
              m.sub = subFiltrado;
              filter.push(m);
            }
          } else {
            this.getAllRoles.forEach((r) => {
              if (this.validarRotaPorRole(m, routesFiltradas, r)) {
                filter.push(m);
                routesFiltradas.push(m.route);
              }
            });
          }
        });
      return filter;
    },
    hideMenu() {
      return !this.filteredMenuList.length;
    },
    pageName() {
      return this.$route.name;
    },
    usuario() {
      return this.getUsuario;
    },
    state() {
      return this.$route.name;
    },
    path() {
      return this.$route.path;
    },
  },
  watch: {
    getControladoreSelecionado() {
      if (this.$router.currentRoute.name === 'dashboard') {
        this.recarregar = true;
        setTimeout(() => {
          this.recarregar = false;
        }, 1E2);
      }
    },
  },
  methods: {
    ...mapActions('importacao', [
      'popularImportacoesAndamento',
      'popularTiposImportacao',
    ]),
    ...mapActions('usuario', [
      'carregarInformacoesUsuario',
    ]),
    ...mapActions('controlador', [
      'carregarControladores',
    ]),
    ...mapActions('implantacao', [
      'carregarImplantacao',
    ]),
    filtrarSubMenu(subMenu) {
      const filter = [];
      const routesFiltradas = [];
      subMenu.forEach((m) => {
        this.getAllRoles.forEach((r) => {
          if (this.validarRotaPorRole(m, routesFiltradas, r)) {
            filter.push(m);
            routesFiltradas.push(m.route);
          }
        });
      });
      return filter;
    },
    validarRotaPorRole(menu, routesFiltradas, role) {
      if (!Array.isArray(menu.role)) {
        return role.startsWith(menu.role) && !routesFiltradas.includes(menu.route);
      }
      const menuRoles = menu.role;
      return menuRoles.indexOf(role) >= 0 && !routesFiltradas.includes(menu.route);
    },
    usaEstiloNovo(path) {
      const novasTelas = [
        '/cliente',
        '/produto',
        '/centro-custo',
        '/usuario',
        '/tipo-investimento',
        '/estrutura-usuario',
        '/importacoes',
        '/workflow',
        '/alcada',
        '/regiao',
        '/tipo-orcamento',
        '/tipo-acao',
        '/unidade-medida',
        '/sso-grupo',
        '/orcamento',
        '/ajuste-verba',
        '/negociacao',
        '/apuracao',
        '/pagamento',
        '/margem-contribuicao',
        '/sellin',
        '/transferencia-posse',
        '/termo-aceite',
        '/gestao-aprovacao',
        '/administracao',
      ];
      return novasTelas.filter(tela => path.indexOf(tela) >= 0).length > 0;
    },
    buscarImportacoesAndamento() {
      if (this.canImport) {
        this.popularImportacoesAndamento(this.importacaoResources.listarAndamento)
          .then(() => {
            this.resetEventLoop(10E3);
          });
      }
    },
    buscarTiposImportacao() {
      if (this.canImport) {
        this.popularTiposImportacao({ resource: this.importacaoResources.listarTipos,
          roles: this.getAllRoles });
      }
    },
    resetEventLoop(timer) {
      if (this.eventLoopTimer === timer) {
        return;
      }
      window.clearInterval(this.eventLoop);
      this.eventLoopTimer = timer;
      this.eventLoopImportacoes();
    },
    eventLoopImportacoes() {
      if (!this.eventLoop && this.canImport) {
        this.eventLoop = setInterval(() => {
          this.buscarImportacoesAndamento();
        }, this.eventLoopTimer);
      }
    },
    toggleSidenav() {
      this.abrirMenu = !this.abrirMenu;
    },
    logoutAceito() {
      this.$refs.modalSessao.close();
      auth.doLogout();
    },
    iniciaAplicacao() {
      this.dicionarioCarregado = true;
      this.buscarImportacoesAndamento();
      this.buscarTiposImportacao();
    },
    recarregarAplicacao() {
      location.reload();
    },
    fecharModalErro() {
      this.$refs.modalErroInicializacaoAplicacao.close();
    },
    carregarTermos() {
      return new Promise((resolve, reject) => {
        this.termoAceiteResources.buscarTermosLogin()
          .then((response) => {
            this.termos = response.data;
            resolve();
          }).catch(reject);
      });
    },
    termoAceito() {
      this.aceito = true;
    },
  },
  mounted() {
    auth.registerSessionListener({
      onSessionExpired: this.$refs.modalSessao.open,
    });

    showInitialLoading();
    Promise.all([
      this.carregarInformacoesUsuario(this.usuarioResources.informacao),
      this.carregarControladores(this.controladorResources.listar),
      this.carregarImplantacao(this.dicionarioResources.implantacao),
    ])
      .then(() => {
        this.carregarTermos();
        this.iniciaAplicacao();
        setTimeout(() => hideInitialLoading(), 3000);
      })
      .catch((e) => {
        if (e.status === 403) {
          this.mensagemModalInicializacao = this.$t('errors.inicializacao_sem_perfil');
        } else {
          this.mensagemModalInicializacao = this.$t('errors.inicializacao');
        }
        this.$refs.modalErroInicializacaoAplicacao.open();
        setTimeout(() => hideInitialLoading());
        window.setTimeout(() => { throw e; });
      });
  },
  beforeDestroy() {
    window.clearInterval(this.eventLoop);
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/Home.vue?vue&type=script&lang=js&